var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('simple-header',{attrs:{"title":'Cargar canción',"back":'/admin/catalogo'}}),_c('section',[_c('form-new-song')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }